<template>
    <div>
        <div class="pl-7 pt-4">
            <div class="font-primaria headline font-weight-bold fontColor1--text">
                CONSULTAR UNIMEDS
            </div>
            <div style="line-height: 8px" class="mt-2 font-secundaria subtitle-2 fontColor1--text" v-if="!$vuetify.breakpoint.xs">
                Home > <span class="font-weight-bold"> Consultar Unimeds </span>
            </div>
            <div class="mt-2 font-secundaria subtitle-2 fontColor1--text" v-else>
                Home > <span class="font-weight-bold"> Consultar Unimeds </span>
            </div>
        </div>
        <v-row class="mt-6">
            <v-col cols="12" class="px-6">
                <v-card class="white card-consulta">
                    <v-row align="center" :class="!$vuetify.breakpoint.xs ? 'px-8 py-2' : 'px-6'" justify="end">
                        <v-col cols="10" sm="5">
                            <search-bar
                                nameInput="searchText"
                                nameButton="searchBtn"
                                ref="barraPesquisa"
                                v-model="barraPesquisa"
                                :placeholder="'pesquisar por código, razão social ou nome fantasia'"
                                @pesquisar="value => pesquisar(value)"
                            />
                        </v-col>
                        <v-col cols="auto" class="mt-2" @click="exportar()">
                            <icon name="download" :size="20" style="cursor: pointer" tooltip="Exportar"/>
                        </v-col>
                        <v-col cols="auto">
                            <button-cadu
                                name="btnLimpar"
                                outline
                                @click="limparFiltro()"
                            >
                                LIMPAR
                            </button-cadu>
                        </v-col>
                        <v-col cols="auto">
                            <button-cadu
                                @click="showFiltro = true"
                            >
                                FILTRAR
                            </button-cadu>
                        </v-col>
                    </v-row>
                    <v-row :class="!$vuetify.breakpoint.xs ? 'px-8 py-2' : 'px-6'">
                        <v-col cols="12">
                            <TabelaConsultarUnimed
                                ref="tabelaUnimeds"
                            />
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <div>
            <FiltroConsultarUnimed
                ref ="filtroConsultarUnimed"
                :value="showFiltro"
                @close="showFiltro = false"
                @filtrar="filtro => filtrar(filtro)"
            />
        </div>

    </div>
</template>

<script>
import TabelaConsultarUnimed from './Shared/TabelaConsultarUnimed'
import FiltroConsultarUnimed from './Shared/FiltroConsultarUnimed'
export default {
  components: {
    TabelaConsultarUnimed,
    FiltroConsultarUnimed
  },
  data () {
    return {
      barraPesquisa: '',
      showFiltro: false
    }
  },
  methods: {
    pesquisar (value) {
      this.$refs.tabelaUnimeds.pesquisar(value)
    },
    filtrar (filtro) {
      this.$refs.tabelaUnimeds.filtrar(filtro)
    },
    limparFiltro () {
      // FINALIZAR METODO
      this.barraPesquisa = ''
      this.$refs.tabelaUnimeds.limparFiltro()
      this.$refs.barraPesquisa.limparCampo()
      this.$refs.filtroConsultarUnimed.limparFiltro()
    },
    exportar () {
      this.$refs.tabelaUnimeds.exportarUnimed()
    }
  }
}
</script>

<style lang="sass" scoped>
.card-consulta
    width: 100%
    min-height: 420px
    border-radius: 20px
</style>
